<template>
  <v-container class="px-0 py-0">
      <v-row class="mr-10 px-0">
        <v-col cols="12" sm="4" md="3">
          <h2 class="texts">Prestador:</h2>
          <p class="texts">{{ info.prest_nome }}</p>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <h2 class="texts">Operadora:</h2>
          <span class="texts">{{ info.oper_nome }}</span>
          <!-- <span class="pl-1">
            <v-icon @click="showOpen=true" small color="primary">fa-info-circle</v-icon>
          </span> -->
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <h2 class="texts">Prazo de faturamento:</h2>
          <p :class="info.is_atrasado ? 'ematraso' : '' " class="texts">
            {{ info.dt_faturamento | formatData}} <span v-if="info.is_atrasado"> Em atraso</span>
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <h2 class="texts">Valor previsto (R$):</h2>
          <p class="texts text-right">{{ info.vl_prev_faturamento | formatPrice }}</p>
        </v-col>
        <v-col cols="12" sm="4" md="1">
          <h2 class="texts">Responsável:</h2>
          <p class="texts">{{ info.owner_username }}</p>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <span v-if="info.login_prestador">
          <h2 class="texts">Ident. do Prestador</h2>
          <p class="texts">{{ info.login_prestador }}</p>
          </span>
        </v-col>
        <v-col cols="12" sm="2" md="3">
          <span v-if="info.tipo_guia_descricao">
          <h2 class="texts">Tipo de guia:</h2>
          <span class="texts">{{ info.tipo_guia_descricao }}</span>
          </span>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <h2 class="texts">Previsão de vencimento:</h2>
          <p class="texts">{{ info.dt_prev_vencimento  | formatData }}</p>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <h2 class="texts">Valor importado (R$):</h2>
          <p class="texts text-right">{{ info.arq_vl_calculado  | formatPrice }}</p>
        </v-col>
        <v-col cols="12" sm="4" md="1">
          <h2 class="texts">Lotes:</h2>
          <span class="texts">{{ info.total_arquivos }} </span>
          <v-tooltip bottom v-if="info.total_arquivos_pendente" color="error">
                  <template v-slot:activator="{ on, attrs }" >
                    <span  style="color:#D0021B" v-bind="attrs" v-on="on" class="pa-0">
                    <v-icon color="error" x-small class="pr-1">fa-exclamation-triangle</v-icon>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ info.total_arquivos_pendente }} lote(s) com crítica</span>
                </v-tooltip>
        </v-col>
      </v-row>
      <v-row class="py-0 px-3 my-0" v-show="warningMessageShow">
        <v-alert dense text :type="warningMessageType" :icon="warningMessageType=='warning'? 'fa fa-exclamation-triangle' : 'fa fa-check-circle'" width="100%">
          {{ warningMessage }}
        </v-alert>
      </v-row>
      <CronogramaModalOperadoraInfo
        :tableInfo="showOpen"
        :showClose="() => showOpen=false"
        :title="info.oper_nome"
      />
    </v-container>
</template>

<script>
import moment from 'moment'
import CronogramaModalOperadoraInfo from './CronogramaModalOperadoraInfo'
export default {
  props: {
    info: Object
  },
  components:{
    CronogramaModalOperadoraInfo
  },
  data() {
    return {
      showOpen: null,
      warningMessageShow: false,
      warningMessage: '',
      warningMessageType: 'warning' 
    }
  },
  filters:{
    formatData(val){
      return  moment(val).format('DD/MM/YYYY')
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  mounted(){
     let message = []
        if(!!this.info.config && this.info.config.FAT_DADOS_ENTREGA_OBRIGATORIO){
          message.push('dados de entrega')
        }
        if(!!this.info.config && this.info.config.FAT_NOTA_FISCAL_OBRIGATORIO){
          message.push('nota fiscal')
        }
        if(!!this.info.config && this.info.config.FAT_CAPA_LOTE_OBRIGATORIO){
          message.push('capa de lote')
        }
        this.warningMessageType = 'warning'
        if(message.length == 1){
          message = message[0]
          message = `Operadora com obrigatoriedade de ${message}.`
        } else if (message.length > 1) {
          let ultima =  message.pop();
          message = message.join(', ') + ' e ' + ultima
          message = `Operadora com obrigatoriedade de ${message}.`
        } else if (this.info.status=="F") {
          message = `Cronograma concluído.` // em  ${this.info.dt_alteracao}
          this.warningMessageType = 'success'
        } else {
          message = ""
        }
        this.warningMessage = message
        this.warningMessageShow = message.length && this.info.status != 'F' ? true : false
  }
}
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
.ematraso {
  color: #FC9D0A;
  font-weight: bold;
}
</style>